import React, { useState } from 'react'
import '../../UI-component/SpidButton/index.css'
import Guest from '../../Layouts/GuestLayout'
import { SpidAPI } from '../../Apis/SpidAPI'
import { FastIdAPI } from '../../Apis/FastIdAPI'
import { useNavigate } from 'react-router-dom'
import { getConfiguration, getServicePath, getStoredConfiguration, getTenantCode } from '../../util'
import ConfigurationAPI from '../../Apis/ConfigurationAPI'

//For execute test SpidValidator
//  src="../assets/images/AgID.svg"
/**
 *
 */
const extraProviderList = {
  Validator: 'Validator'
  //ValidatorLocal: "ValidatorLocal"
}

const CIE_ALLOWED_TENANTS = ["F528", "I947", "B175", "B559"]

export default function AccessoServizi(props) {
  //const navigate = useNavigate()
  const [showPasswordForm, setShowPasswordForm] = useState(false)
  const [password, setPassword] = useState('')
  const [isPasswordValid, setIsPasswordValid] = useState(false)

  // Lista delle password valide per l'autologin
  const validPasswords = ['admin123', 'test2024', 'dev_access']

  const tenantCode = getTenantCode();

  const redirectToService = async (token) => {
    await getConfiguration(token, window.location.origin);
    const redirect = getServicePath();
    // console.log("redirect", redirect);
    window.location.href = redirect;
  }

  //DEVELOPMENT ONLY DONT OPTIMIZE
  const getToken = async (loginType = 'spid') => {
    try {
      FastIdAPI.getToken(false, loginType).then(res => {
        localStorage.getItem('destination') ?? localStorage.setItem('destination', '/');
        //let redirect = localStorage.getItem('destination') ?? "/";

        const data = res.data
        //const token = data.access_token
        const spidToken = data.token

        window.location.href = `${process.env?.REACT_APP_DOMAIN_FASTID}${spidToken}`;

        //localStorage.setItem('access_token', token);
        //sessionStorage.setItem("isLoggedIn", true);

        //navigate(redirect);

      })
    } catch (err) {
      console.log('error getToken', err)
    }
  }

  const autoLogin = async () => {
    localStorage.getItem('destination') ?? localStorage.setItem('destination', '/');

    let redirect = localStorage.getItem('destination') ?? "/";
    const path = redirect;

    try {
      SpidAPI.autoLogin(false).then(res => {
        const data = res.data
        const token = data.access_token

        if (!token) {
          alert('Unable to login. Please try after some time.')
          return
        }



        localStorage.setItem('access_token', token);
        localStorage.setItem('user', JSON.stringify(data.user));
        localStorage.getItem('destination') ?? localStorage.setItem('destination', '/');
        sessionStorage.setItem("isLoggedIn", true);

        redirectToService(token);

      })
    } catch (err) {
      console.log('error autologin', err)
    }
  }

  const handlePasswordSubmit = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    
    if (validPasswords.includes(password)) {
      setIsPasswordValid(true)
      setShowPasswordForm(false)
      // Chiamiamo autoLogin direttamente qui
      autoLogin()
    } else {
      alert('Password non corretta!')
      setPassword('')
    }
  }

  const handleShowPasswordForm = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowPasswordForm(true)
    setPassword('')
    setIsPasswordValid(false)
  }

  //casuing equal key component error (just for testing purposes)
  const mappingProvider = () => {
    let ret = Object.entries(extraProviderList).map(function (_ref3) {
      const entityName = _ref3[0]
      const entityID = _ref3[1]
      const logo = '../assets/images/logo-agid-test.png'

      return {
        protocols: ['SAML'],
        entityName: entityName,
        entityID: entityID,
        logo: logo,
        active: true
      }
    })

    return ret
  }

  const renderCIE = () => (
    <div className='cmp-text-button mt-2'>
      <h2 className='title-xxlarge mb-0'>CIE</h2>
      <div className='text-wrapper'>
        <p style={{ padding: '10px' }} className='subtitle-small mb-3'>
          La <strong>Carta d'Identità Elettronica (CIE)</strong> è il documento d'identità dei cittadini italiani che consente l'accesso ai servizi online della Pubblica Amministrazione.
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          padding: '10px',
          justifyContent: 'space-between',
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '1rem'
        }}
      >
        <div style={{ flex: '1 1 250px' }}>
          <a className='simple-link spid-link' href='https://www.cartaidentita.interno.gov.it/'>
            Maggiori informazioni su CIE{' '}
            <span className='visually-hidden'>
              Maggiori informazioni su CIE
            </span>
          </a>
          <br></br>
          <a
            className='simple-link spid-link'
            href='https://www.cartaidentita.interno.gov.it/identificazione-digitale/entra-con-cie/'
          >
            Come accedere con CIE{' '}
            <span className='visually-hidden'>Come accedere con CIE</span>
          </a>
          <br></br>
          <a
            className='simple-link spid-link'
            href='https://www.cartaidentita.interno.gov.it/contatti/'
          >
            Serve aiuto?{' '}
            <span className='visually-hidden'>Serve aiuto?</span>
          </a>
        </div>

        <div className='button-wrapper mb-2 spid-btn-div' style={{ flex: '0 0 auto' }}>
          <button onClick={() => getToken('cie')} className="spid-login-button cursor-pointer">
            <img
              src='../assets/images/cie-button-link-hover.png'
              alt="Logo CIE"
              className="spid-button-link-hover spid-btn"
            />
          </button>
        </div>

      </div>
      <div className='mt-4' style={{ textAlign: 'center' }}>
        <img
          src='../assets/images/spid-cie-agid-logo-lb.png'
          // spid-agid-logo-lb.png
          className='icon-error'
          alt='Spid AgIDCIE Logo'
          style={{
            padding: '10px',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            width: '30vw',
            minWidth: '280px',
            maxWidth: '400px'
          }}
        />
      </div>
    </div>
  )


  return (
    <Guest
      auth={props.auth}
      errors={props.errors}
      key={Math.random() * 31 * Math.random() * 11}
    >
      <div className='container' id='main-container'>
        <div className='row'>
          <div className='col-12 col-lg-10 offset-lg-1'>
            <div className='cmp-breadcrumbs' role='navigation'>
              <nav className='breadcrumb-container' aria-label='breadcrumb'>
                <ol className='breadcrumb p-0' data-element='breadcrumb'>
                  <li className='breadcrumb-item'>
                    <a href='/'>Home</a>
                    <span className='separator'>/</span>
                  </li>
                  <li className='breadcrumb-item active' aria-current='page'>
                    Accedi
                  </li>
                </ol>
              </nav>
            </div>{' '}
            <div className='cmp-heading pb-3 pb-lg-4'>
              <h1 className='title-xxxlarge'>Accedi</h1>

              <p className='subtitle-small'>
                Per accedere al sito e ai suoi servizi, utilizza una delle
                seguenti modalità.
              </p>
            </div>
          </div>
        </div>
        <hr className='d-none d-lg-block mt-0 mb-4' />
        <div className='row'>
          <div className='col-12 col-lg-8 offset-lg-2'>
            <div className='cmp-text-button mt-3'>
              <h2 className='title-xxlarge mb-0'>SPID</h2>
              <div className='text-wrapper'>
                <p style={{ padding: '10px' }} className='subtitle-small mb-3'>
                  SPID, il{' '}
                  <strong>Sistema Pubblico di Identità Digitale</strong>, è il
                  sistema di accesso che consente di utilizzare, con un'identità
                  digitale unica, i servizi online della Pubblica
                  Amministrazione e dei privati accreditati. Se sei già in
                  possesso di un'identità digitale, accedi con le credenziali
                  del tuo gestore. Se non hai ancora un'identità digitale,
                  richiedila ad uno dei gestori.
                </p>
              </div>
              <div
                style={{
                  display: 'flex',
                  padding: '10px',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: '1rem'
                }}
              >
                <div style={{ flex: '1 1 250px' }}>
                  <a className='simple-link spid-link' href='https://www.spid.gov.it/'>
                    Maggiori informazioni su SPID{' '}
                    <span className='visually-hidden'>
                      Maggiori informazioni su SPID
                    </span>
                  </a>
                  <br></br>
                  <a
                    className='simple-link spid-link'
                    href='https://www.spid.gov.it/cos-e-spid/come-attivare-spid/'
                  >
                    Come attivare SPID{' '}
                    <span className='visually-hidden'>Come attivare SPID</span>
                  </a>
                  <br></br>
                  <a
                    className='simple-link spid-link'
                    href='https://test-www.spid.gov.it/ottieni-assistenza-dagli-identity-provider/'
                  >
                    Serve aiuto?{' '}
                    <span className='visually-hidden'>Serve aiuto?</span>
                  </a>
                </div>

                <div className='button-wrapper mb-2 spid-btn-div' style={{ flex: '0 0 auto' }}>
                  <button onClick={() => getToken('spid')} className="spid-login-button cursor-pointer">
                    <img
                      src='../assets/images/spid-button-link-hover.png'
                      alt="Logo SPID"
                      className="spid-button-link-hover spid-btn"
                    />
                  </button>
                </div>
              </div>
            </div>
            
            {renderCIE()}
            {/* <div class='cmp-text-button'>
              <h2 class='title-xxlarge mb-0'>Altre utenze</h2>
              <div class='text-wrapper'>
                <p class='subtitle-small mb-3'>
                  In alternativa puoi utilizzare le seguenti modalità.
                </p>
              </div>
              <div class='button-wrapper d-md-flex'>
                <a
                  href='https://backoffice.stellanello.nemea.cloud/'
                  className='btn btn-outline-primary btn-re bg-white'
                >
                  <span>Accedi come dipendente</span>
                </a>
              </div>
            </div> */}

            {
              process.env?.REACT_APP_AUTOLOGIN === "true" &&
              <div className='col-12' style={{ marginTop: '2rem', padding: 0, marginBottom: '2rem' }}>
                {!showPasswordForm ? (
                  <div className='text-center text-lg-start'>
                    <button
                      id='step1Next'
                      type='button'
                      className='btn btn-warning btn-sm steppers-btn-confirm btn-next-step'
                      onClick={handleShowPasswordForm}
                      style={{ display: 'inline-block' }}
                    >
                      <span className='text-button-sm'>TEST: Auto Login</span>
                      <svg className='icon icon-white icon-sm' aria-hidden='true'>
                        <use href='../assets/bootstrap-italia/dist/svg/sprites.svg#it-refresh'></use>
                      </svg>
                    </button>
                  </div>
                ) : (
                  <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0 0.5rem'
                  }}>
                    <form onSubmit={(e) => { e.preventDefault(); handlePasswordSubmit(); }} style={{ display: 'flex', alignItems: 'center', gap: '0.25rem', flexWrap: 'nowrap', justifyContent: 'center' }}>
                      <input
                        type='password'
                        className='form-control form-control-sm'
                        placeholder='Password'
                        value={password}
                        onChange={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setPassword(e.target.value);
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            e.preventDefault();
                            e.stopPropagation();
                            handlePasswordSubmit();
                          }
                        }}
                        style={{ width: '140px', minWidth: '120px', flex: '1 1 auto', maxWidth: '200px' }}
                        autoComplete="off"
                        autoFocus
                      />
                      <button
                        type='submit'
                        className='btn btn-success btn-sm'
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          handlePasswordSubmit();
                        }}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        Accedi
                      </button>
                      <button
                        type='button'
                        className='btn btn-secondary btn-sm'
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setShowPasswordForm(false);
                        }}
                        style={{ whiteSpace: 'nowrap' }}
                      >
                        Annulla
                      </button>
                    </form>
                  </div>
                )}
              </div>
            }
          </div>
        </div>
      </div>

      {/** <HelpBox
        helpBoxInfo={{
          muniQuestionLink:
            'https://stellanello.nemea.cloud/domande-frequenti/',
          muniHelpLink: 'https://stellanello.nemea.cloud/servizi/assistenza/',
          greenNumber: 'tel:+39 0182 668000',
          bookLink: 'https://stellanello.nemea.cloud/servizi/prenotazioni/',
          rDisservice: ''
        }}
      /> 
     */}
    </Guest>
  )
}
